import React, { useEffect, useState, useMemo } from 'react';
import { fetcher } from '../../../../../helpers/fetcher';
import { configApiLinks } from '../../../../../configApiLinks';
import {
  setCheckData,
} from '../../../../../actions/checks';
import { useDispatch } from 'react-redux';

export const useReceiptsOrdersList = () => {
  const [modalShow, setModalShow] = useState(false);
  const [receiptsOrdersData, setReceiptsOrdersData] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [filterDateStart, setFilterDateStart] = useState((new Date()).setDate(new Date().getDate() - 7));
  const [filterDateEnd, setFilterDateEnd] = useState(new Date());
  const [docNumberSearch, setDocNumberSearch] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalShow === true) {
      getReceiptsOrders(filterDateStart, filterDateEnd);
    }
  }, [modalShow]);

  const getReceiptsOrders = (inDateStart, inDateEnd) => {
    if (inDateStart !== filterDateStart) {
      setFilterDateStart(inDateStart);
    }
    if (inDateEnd !== filterDateEnd) {
      setFilterDateEnd(inDateEnd);
    }
    // if (inFrId !== frId) {
    //   setFrId(inFrId);
    // }
    setShowLoader(true);
    fetcher(configApiLinks.getReceiptsOrders, 'POST', {
      dateStart: Date.parse(inDateStart),
      dateEnd: Date.parse(inDateEnd),
      // frId: inFrId,
    }).then((data) => {
      setShowLoader(false);
      setReceiptsOrdersData(data);
    });
  };

  const selectReceiptOrder = (receiptId) => {
    setShowLoader(true);
    fetcher(configApiLinks.selectReceiptOrder, 'POST', {
      receiptId: receiptId
    }).then((data) => {
      setShowLoader(false);
      dispatch(setCheckData(data));
      setModalShow(false);
    }).catch((data) => {
      setShowLoader(false);
      console.error('Error selecting order receipt:', data);
    });
  };

  const filteredReceiptsList = useMemo(() => {
    if (!receiptsOrdersData?.receipts) return [];
    let rows = receiptsOrdersData.receipts.map((row) => ({
      ...row,
    }));
    console.log('rows', rows);
    if (docNumberSearch) {
      rows = rows.filter((row) =>
        (row.docNumber?.toString().endsWith(docNumberSearch) || row.webOrderId?.toString().endsWith(docNumberSearch) || (docNumberSearch.length > 2 && row.phone?.toString().includes(docNumberSearch)))
      );
    }
    console.log('rowsF', rows);
    return rows;
  }, [receiptsOrdersData?.receipts, filterDateStart, filterDateEnd, docNumberSearch]);

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    getReceiptsOrders,
    selectReceiptOrder,
    modalShow,
    receiptsOrdersData,
    filteredReceiptsList,
    showLoader,
    filterDateStart,
    filterDateEnd,
    docNumberSearch,
    setDocNumberSearch,
    setModalShow,
  };
};
